import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(({ breakpoints, tokens }) => ({
  notifications: {
    position: 'relative',
  },
  stack: {
    position: 'fixed',
    top: 92,
    right: 20,
    zIndex: 10000,
    width: 'calc(100% - 40px)',
    maxWidth: 450,

    [breakpoints.up('xs')]: {
      width: 'auto',
    },
    [breakpoints.up('sm')]: {
      width: 360,
    },
    [breakpoints.up('md')]: {
      width: 450,
    },
  },

  content: {
    color: tokens.colors.text.dark.primary,
  },

  overflowWrap: {
    minWidth: 0,
    overflowWrap: 'break-word',
  },
}));
